$(function() {
    if($('.addition_chaos_gallery').length) {
        var photoSlider = document.querySelectorAll('.addition_chaos_gallery');
        $(photoSlider).each(function(){
            var $this = $(this),
                $arrowprev = $this.closest('.addition_chaos_gallery_outer').find('.arrow-prev'),
                $arrownext = $this.closest('.addition_chaos_gallery_outer').find('.arrow-next');
                $this.slick({
                    lazyLoad: 'ondemand',
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    arrows: true,
                    prevArrow: $arrowprev,
                    nextArrow: $arrownext,
                    infinite: false,
                    responsive: [
                        {
                            breakpoint: 767,
                            settings: {
                                slidesToShow: 2,
                            }
                        },
                        {
                            breakpoint: 577,
                            settings: {
                                slidesToShow: 1,
                            }
                        }
                    ]
                })
        })
    }

    // ========================================================== chaos_gallery =========================================== //
    var indicator;

    $(document).on('click', '.addition_chaos_gallery_frame:not(.slick-slide)', function () {
        if (window.innerWidth > 567) {
            var windowsTop = $(window).scrollTop(),
                frame = $(this),
                frameParent = frame.closest('.addition_chaos_gallery_item'),
                frameInit = frameParent.attr('data-init'),
                frameTop = frame.offset().top,
                frameLeft = frame.offset().left,
                frameW = frame.outerWidth(),
                frameH = frame.outerHeight(),
                frameImg = frame.find('.addition_chaos_gallery_frame_img'),
                frameImgBigSrc = frameImg.attr('data-big-src'),
                frameAllParent = frame.closest('.addition_chaos_gallery_outer'),
                frameSliderWraper = frameAllParent.find('.addition_chaos_gallery_slider_wrapper'),
                frameSlider = frameSliderWraper.find('.addition_chaos_gallery_slider'),
                allImgParent = frameAllParent.find('.addition_chaos_gallery_item'),
                allImgSlider = allImgParent.find('.addition_chaos_gallery_frame');

            allImgParent.each(function () {
                allImgParent = $(this),
                allImgParentInit = allImgParent.attr('data-init'),
                allImgFrame = allImgParent.find('.addition_chaos_gallery_frame');
                allImgFrame.attr('data-slider-init', allImgParentInit);
            });
                c = jQuery.makeArray(allImgSlider);
                c.sort(function (a, b) {
                a = $(a).attr('data-slider-init');
                b = $(b).attr('data-slider-init');
                return a < b ? -1 : a > b ? 1 : 0
            });
            $(c).clone().appendTo(frameSlider);
            frameSlider.find('.addition_chaos_gallery_frame').css({
                'height':window.innerHeight,
            })
            cloneImg = frameSlider.find('.addition_chaos_gallery_frame_img');
            cloneImg.each(function () {
                cloneImg = $(this);
                cloneImg.wrap('<div class="wrap_img"></div>');
                cloneImgBigSrc = cloneImg.attr('data-big-src'),
                cloneImgWrap = cloneImg.closest('.wrap_img');
                cloneImgWrap.css({
                    'background':'url('+ cloneImgBigSrc +') center center/cover no-repeat',
                })
                cloneImg.remove();
            });
            frameSliderWraper.css({
                'background':'url('+ frameImgBigSrc +') center center/cover no-repeat',
                'top':frameTop-windowsTop,
                'left':frameLeft,
                'width':frameW,
                'height':frameH
            });
            $('body').addClass('hidden');
            frameSliderWraper.animate({
                'top':0,
                'left':0,
                'width':'100%',
                'height':'100%',
            }, function () {
                $(this).addClass('all_done');
                $(this).css({
                    'background':'',
                })
                frameSlider.on('init', function () {
                    frameSlider.find('.slick-dots li.slick-active').click();
                })
                frameSlider.slick({
                    dots: true,
                    arrows: true,
                    vertical: true,
                    verticalSwiping: true,
                    initialSlide: frameInit,
                });

                indicator = new WheelIndicator({
                    preventMouse: true,
                    callback: function(e) {
                        if (e.direction == "up") {
                            frameSlider.slick('slickPrev');
                        } else {
                            frameSlider.slick('slickNext');
                        }
                    }
                });

            })
        }
    })
    $(document).on("mouseover", ".addition_chaos_gallery_slider .slick-next", function(event){
        $('.addition_chaos_gallery_slider').find('.slick-track').stop().animate({
            'top':'-50px',
        });
        $('.addition_chaos_gallery_slider').find('.addition_chaos_gallery_frame_info').stop().animate({
            'bottom':'-50px',
        });
    });
    $(document).on("mouseout", ".addition_chaos_gallery_slider .slick-next", function(event){
        $('.addition_chaos_gallery_slider').find('.slick-track').stop().animate({
            'top':0,
        });
        $('.addition_chaos_gallery_slider').find('.addition_chaos_gallery_frame_info').stop().animate({
            'bottom':0,
        }, function () {
            $(this).removeAttr('style');
        });
    });
    $(document).on("mouseover", ".addition_chaos_gallery_slider .slick-prev", function(event){
        $('.addition_chaos_gallery_slider').find('.slick-track').stop().animate({
            'top':'50px',
        });
        $('.addition_chaos_gallery_slider').find('.addition_chaos_gallery_frame_info').stop().animate({
            'bottom':'50px',
        });
    });
    $(document).on("mouseout", ".addition_chaos_gallery_slider .slick-prev", function(event){
        $('.addition_chaos_gallery_slider').find('.slick-track').stop().animate({
            'top':0,
        });
        $('.addition_chaos_gallery_slider').find('.addition_chaos_gallery_frame_info').stop().animate({
            'bottom':0,
        }, function () {
            $(this).removeAttr('style');
        });
    });
    $(document).on('click', '.addition_chaos_gallery_slider_wrapper_close', function () {
        var windowsTop = $(window).scrollTop(),
            close = $(this),
            closeAllParent = close.closest('.addition_chaos_gallery_outer'),
            closeParent = close.closest('.addition_chaos_gallery_slider_wrapper'),
            closeParentSlider = closeParent.find('.addition_chaos_gallery_slider'),
            closeActiveSlide = closeParent.find('.slick-current.slick-active'),
            closeActiveSlideInit = closeActiveSlide.attr('data-slider-init'),

            frameBack = closeAllParent.find('.addition_chaos_gallery_frame:not(.slick-slide)[data-slider-init="'+ closeActiveSlideInit +'"]'),
            frameBackImg = frameBack.find('.addition_chaos_gallery_frame_img'),
            frameBackImgBigSrc = frameBackImg.attr('data-big-src'),
            frameBackTop = frameBack.offset().top,
            frameBackLeft = frameBack.offset().left,
            frameW = frameBack.outerWidth(),
            frameH = frameBack.outerHeight();
        closeParent.removeClass('all_done')
        .css({
            'background':'url("'+ frameBackImgBigSrc +'") center center/cover no-repeat',
        });
        closeParentSlider.slick('unslick');
        indicator.destroy();
        closeParentSlider.empty();
        closeParent.animate({
            'top':frameBackTop-windowsTop,
            'left':frameBackLeft,
            'width':frameW,
            'height':frameH,
        }, function () {
            $(this).removeAttr('style');
            $('body').removeClass('hidden');
        })
    })
})
